<template>
  <div class="product-info-skeleton-loader">
    <g-skeleton class="product-info-skeleton-loader__heading" />
    <g-skeleton class="product-info-skeleton-loader__variation" />
    <g-skeleton class="product-info-skeleton-loader__part-number" />
    <g-skeleton class="product-info-skeleton-loader__price" />
    <div class="product-info-skeleton-loader__filter">
      <div class="product-info-skeleton-loader__filter__heading">
        <g-skeleton class="product-info-skeleton-loader__filter-title" />
        <g-skeleton class="product-info-skeleton-loader__filter-icon" />
      </div>
      <div class="product-info-skeleton-loader__filter__buttons">
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
      </div>
    </div>
    <div class="product-info-skeleton-loader__filter">
      <div class="product-info-skeleton-loader__filter__heading">
        <g-skeleton class="product-info-skeleton-loader__filter-title" />
        <g-skeleton class="product-info-skeleton-loader__filter-icon" />
      </div>
      <div class="product-info-skeleton-loader__filter__buttons">
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
        <g-skeleton class="product-info-skeleton-loader__filter-option" />
      </div>
    </div>
    <div class="product-info-skeleton-loader__color-picker">
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
      <g-skeleton class="product-info-skeleton-loader__color-picker-option" />
    </div>
    <g-skeleton class="product-info-skeleton-loader__add-to-cart" />
  </div>
</template>

<style lang="scss" scoped>
  .product-info-skeleton-loader {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;

    @include productBreakpoint(desktop-s) {
      margin-top: 0;
    }

    &__heading {
      height: 2.25rem;
      width: 100%;

      @include productBreakpoint(desktop-m) {
        max-width: 35rem;
      }
    }

    &__variation {
      height: 1.5rem;
      width: 14rem;
    }

    &__part-number {
      height: 1rem;
      width: 7rem;
    }

    &__price {
      height: 3rem;
      width: 14rem;
    }

    &__filter-title {
      height: 1rem;
      width: 4rem;
    }

    &__filter-icon {
      height: 1rem;
      width: 1rem;
      border-radius: 50%;
    }

    &__filter-option {
      height: 1.5rem;
      width: 6rem;

      @include productBreakpoint(desktop-s) {
        width: 8rem;
      }
    }

    &__color-picker-option {
      width: 4rem;
      height: 4rem;

      @include breakpoint(sm) {
        height: 5.25rem;
        width: 5.25rem;
      }
    }

    &__add-to-cart {
      height: 3rem;
      width: 14rem;
    }

    &__filter {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      &__heading {
        display: flex;
        gap: 0.5rem;
      }

      &__buttons {
        display: flex;
        gap: 0.5rem;
      }
    }

    &__color-picker {
      display: flex;
      flex-flow: row wrap;
      gap: 0.6em;
      max-width: 100%;

      @include productBreakpoint(desktop-m) {
        max-width: 570px;
      }
    }
  }
</style>
